import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// URL segments map
const URL_MAP = {
  farmAnimal: 'farm-animals',
  crop: 'crops',
  farmEquipment: 'farm-equipments',
  suppliesFeed: 'supplies-feed',
  otherFarmProperty: 'other-farm-properties',
};
const DEFAULT_EXEMPTION = '26-2-103';

export default function FarmAssetsModal({ isOpen, onClose, caseId, item, onSave, exemptions, scope, type }) {
  const [formState, setFormState] = useState({
    description: '',
    amount: '',
    exemption_code: DEFAULT_EXEMPTION,
    exemption_amount: ''
  });

  useEffect(() => {
    if (item) {
      setFormState({
        description: item.description,
        amount: item.amount,
        exemption_code: item.exemption_code || DEFAULT_EXEMPTION,
        exemption_amount: item.exemption_amount || ''
      });
    } else {
      setFormState({
        description: '',
        amount: '',
        exemption_code: DEFAULT_EXEMPTION,
        exemption_amount: ''
      });
    }
  }, [item]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormState(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const urlType = URL_MAP[type];
    const path = item
      ? `/${item.id}/edit/`
      : '/add/';
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/case/${caseId}/${urlType}${path}`,
      {
        method: item ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        },
        body: JSON.stringify(formState)
      }
    );
    const saved = await res.json();
    onSave({ ...saved, urlKey: type });
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
        <h3 className="text-lg font-semibold mb-4">{item ? 'Edit' : 'Add'} Farm Asset</h3>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="col-span-2">
            <label className="block text-sm font-medium">Description</label>
            <textarea
              name="description"
              value={formState.description}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 col-span-2">
            <div>
              <label className="block text-sm font-medium">Amount</label>
              <input
                type="number"
                name="amount"
                value={formState.amount}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Exemption Amount</label>
              <input
                type="number"
                name="exemption_amount"
                value={formState.exemption_amount}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div className="col-span-2">
            <label className="block text-sm font-medium">Exemption Code</label>
            <select
              name="exemption_code"
              value={formState.exemption_code}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
              {exemptions.map(ex => (
                <option key={ex.law} value={ex.law}>
                  {ex.asset_name} ({ex.law})
                </option>
              ))}
            </select>
          </div>
          <div className="flex justify-end space-x-2 pt-4 col-span-2">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300">
              Cancel
            </button>
            <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">
              {item ? 'Save' : 'Add'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

FarmAssetsModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  caseId: PropTypes.string.isRequired,
  item: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  exemptions: PropTypes.array.isRequired,
  scope: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};